import React from 'react'
import { useTranslation } from 'react-i18next'
import { AddressEntityType, EquipmentMatrixSurfaceMountedInstallation } from 'types/ApiResponse'
import checkMarkYes from 'assets/images/icons/checkMarkYes.svg'
import checkMarkNo from 'assets/images/icons/checkMarkNo.svg'
import {
  StyledDataColumn,
  StyledDataContainer,
  StyledDataProperty,
  StyledHeader,
  StyledPropertyLabel,
  StyledPropertyValue,
  StyledSectionContainer,
} from '../PropertyInfo.styled'
import { EquipmentMethod } from 'types/EquipmentMethod'

const EquipmentInfo = (props: any) => {
  const { propertyData }: { propertyData: AddressEntityType } = props
  const { t } = useTranslation()
  const equipmentMatrix = propertyData.propertyDetails?.equipmentMatrix
  const method = propertyData?.propertyDetails?.equipmentMethod

  const getBooleanValue = (value?: boolean) => {
    return (
      <>
        {value ? (
          <img src={checkMarkYes} alt="checkMarkYes" />
        ) : value === false ? (
          <img src={checkMarkNo} alt="checkMarkNo" />
        ) : null}
        {value ? t('common.yes') : value === null ? '—' : value === false ? t('common.no') : '—'}
      </>
    )
  }

  return (
    <StyledSectionContainer>
      <StyledHeader>{t('newAddressModal.furnishingTab.label')}</StyledHeader>
      <StyledDataContainer>
        <StyledDataColumn>
          <StyledDataProperty>
            <StyledPropertyLabel>
              {t('newAddressModal.furnishingTab.equipmentMethod.label')}
            </StyledPropertyLabel>
            <StyledPropertyValue>
              {propertyData?.propertyDetails?.equipmentMethod
                ? t(
                    `newAddressModal.furnishingTab.equipmentMethod.${propertyData?.propertyDetails?.equipmentMethod?.toLowerCase()}`
                  )
                : '—'}
            </StyledPropertyValue>
          </StyledDataProperty>
          {method === EquipmentMethod.SIMPLE && (
            <StyledDataProperty>
              <StyledPropertyLabel>{t('addressModal.equipmentLevel')}</StyledPropertyLabel>
              <StyledPropertyValue>
                {propertyData?.propertyDetails?.equipmentValue
                  ? t(
                      `equipmentValue.${propertyData?.propertyDetails?.equipmentValue?.toLowerCase()}`
                    )
                  : '—'}
              </StyledPropertyValue>
            </StyledDataProperty>
          )}
          {method === EquipmentMethod.DETAILED && (
            <>
              <StyledDataProperty>
                <StyledPropertyLabel>
                  {t('newAddressModal.furnishingTab.heatingOptions.label')}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {equipmentMatrix?.heating
                    ? t(`equipmentMatrix.heating.${equipmentMatrix?.heating?.toLowerCase()}`)
                    : '—'}
                </StyledPropertyValue>
              </StyledDataProperty>
              {/* <StyledDataProperty>
                <StyledPropertyLabel>
                  {t('newAddressModal.furnishingTab.heatingSystem')}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {getBooleanValue(equipmentMatrix?.heatingSystem)}
                </StyledPropertyValue>
              </StyledDataProperty> */}
              <StyledDataProperty>
                <StyledPropertyLabel>
                  {t('newAddressModal.furnishingTab.roofOptions.label')}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {equipmentMatrix?.roofCovering
                    ? t(
                        `equipmentMatrix.roofCovering.${equipmentMatrix?.roofCovering?.toLowerCase()}`
                      )
                    : '—'}
                </StyledPropertyValue>
              </StyledDataProperty>
              <StyledDataProperty>
                <StyledPropertyLabel>
                  {t('newAddressModal.furnishingTab.windowsOptions.label')}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {equipmentMatrix?.windows
                    ? t(`equipmentMatrix.windows.${equipmentMatrix?.windows?.toLowerCase()}`)
                    : '—'}
                </StyledPropertyValue>
              </StyledDataProperty>
              <StyledDataProperty>
                <StyledPropertyLabel>
                  {t('newAddressModal.furnishingTab.storageOptions.label')}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {equipmentMatrix?.storeRoom
                    ? t(`equipmentMatrix.storeRoom.${equipmentMatrix?.storeRoom?.toLowerCase()}`)
                    : '—'}
                </StyledPropertyValue>
              </StyledDataProperty>
              <StyledDataProperty>
                <StyledPropertyLabel>
                  {t('newAddressModal.furnishingTab.floorCoveringOptions.label')}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {equipmentMatrix?.floorCovering
                    ? t(
                        `equipmentMatrix.floorCovering.${equipmentMatrix?.floorCovering?.toLowerCase()}`
                      )
                    : '—'}
                </StyledPropertyValue>
              </StyledDataProperty>
              <StyledDataProperty>
                <StyledPropertyLabel>
                  {t('newAddressModal.furnishingTab.outdoorLivingAreaOptions.label')}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {equipmentMatrix?.residentialArea
                    ? t(
                        `equipmentMatrix.residentialArea.${equipmentMatrix?.residentialArea?.toLowerCase()}`
                      )
                    : '—'}
                </StyledPropertyValue>
              </StyledDataProperty>
            </>
          )}
        </StyledDataColumn>
        {method === EquipmentMethod.DETAILED ? (
          <StyledDataColumn>
            <StyledDataProperty>
              <StyledPropertyLabel>
                {t('newAddressModal.furnishingTab.bathOptions.label')}
              </StyledPropertyLabel>
              <StyledPropertyValue>
                {equipmentMatrix?.bathroom
                  ? t(`equipmentMatrix.bathroom.${equipmentMatrix?.bathroom?.toLowerCase()}`)
                  : '—'}
              </StyledPropertyValue>
            </StyledDataProperty>
            <StyledDataProperty>
              <StyledPropertyLabel>
                {t('newAddressModal.furnishingTab.separateGuestToilet')}
              </StyledPropertyLabel>
              <StyledPropertyValue>
                {getBooleanValue(equipmentMatrix?.guestToilet)}
              </StyledPropertyValue>
            </StyledDataProperty>
            <StyledDataProperty>
              <StyledPropertyLabel>
                {t('newAddressModal.furnishingTab.insulatedOuterWalls')}
              </StyledPropertyLabel>
              <StyledPropertyValue>
                {getBooleanValue(equipmentMatrix?.insulatedExteriorWalls)}
              </StyledPropertyValue>
            </StyledDataProperty>
            <StyledDataProperty>
              <StyledPropertyLabel>
                {t('newAddressModal.furnishingTab.linesOnPlaster')}
              </StyledPropertyLabel>
              <StyledPropertyValue>
                {equipmentMatrix?.surfaceMountedInstallation
                  ? getBooleanValue(
                      equipmentMatrix?.surfaceMountedInstallation ===
                        EquipmentMatrixSurfaceMountedInstallation.CABLES_ON_WALLS
                    )
                  : '—'}
              </StyledPropertyValue>
            </StyledDataProperty>
            <StyledDataProperty>
              <StyledPropertyLabel>
                {t('newAddressModal.furnishingTab.fireplace')}
              </StyledPropertyLabel>
              <StyledPropertyValue>
                {getBooleanValue(equipmentMatrix?.fireplace)}
              </StyledPropertyValue>
            </StyledDataProperty>
            <StyledDataProperty>
              <StyledPropertyLabel>{t('newAddressModal.furnishingTab.sauna')}</StyledPropertyLabel>
              <StyledPropertyValue>{getBooleanValue(equipmentMatrix?.sauna)}</StyledPropertyValue>
            </StyledDataProperty>
          </StyledDataColumn>
        ) : (
          <StyledDataColumn />
        )}
      </StyledDataContainer>
    </StyledSectionContainer>
  )
}

export default EquipmentInfo
